import axios from 'axios';
import { auth } from '../firebase/firebaseConfig';

const getAuthToken = () => {
  return process.env.REACT_APP_API_BEARER_TOKEN || localStorage.getItem('api_bearer_token') || '';
};

// Configurar la instancia de axios
// Nota: Con el proxy configurado en package.json, las rutas deben ser relativas
// El proxy redirige automáticamente las peticiones a http://localhost/services/ws
// En desarrollo: usa ruta relativa (el proxy maneja el resto)
// En producción: usa la URL completa desde la variable de entorno
const baseURL = process.env.REACT_APP_DOTONIWOOFAPI_BASE_URL || '';

export const dotoniwoofApi = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: false
});

// Interceptor de request para agregar el token automáticamente
dotoniwoofApi.interceptors.request.use(
    async (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const firebaseUser = auth.currentUser;
        if (firebaseUser) {
            const idToken = await firebaseUser.getIdToken();
            config.headers['X-Firebase-Token'] = idToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor de response para manejar errores
dotoniwoofApi.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            console.error('Token inválido o expirado');
            // Aquí podrías redirigir al login si es necesario
        }
        return Promise.reject(error);
    }
);